module.exports = __webpack_public_path__ + "static/img/card_5_1.33fe760.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_5_1.png
// module id = ET8w
// module chunks = 0